import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import { Box, Modal, Tab, Tabs, Typography } from "@mui/material";
import ValidateTaxModal from "components/modals/ValidateTaxModal";
import { Button } from "components/reusable/button/Button";
import { IconStyledButton } from "components/reusable/button/Button.style";
import { Span } from "components/reusable/typography/Typography.style";
import dayjs from "dayjs";
import html2pdf from "html2pdf.js";
import { useRef, useState, useEffect } from "react";
import { AddNewBusinessContainer } from "../../../components/modals/Modals.style";
import FlexComp from "../../../components/reusable/flex/Flex";
import BusinessData from "./BusinessData";
import PersonalData from "./PersonalData";
import RentalData from "./RentalData";
import TruckData from "./TruckData";
import Formation1099 from "./Formation1099";

const ShowClientModal = ({
  generalBusinessModal,
  setGeneralBusinessModal,
  modalData,
  handleYesClick,
  download,
}) => {
  console.log(modalData, "modalData");
  const componentRef = useRef();

  const [isValidateTaxModal, setIsValidateTaxModal] = useState(false);

  // Map to get taxYear field based on the array name
  const taxYearKeyMap = {
    personalCollectionTaskId: "prepSheetId",
    generalBusinessTaskId: "businessInfoId",
    rentalPropertyTaskId: "rentalPropertyId",
    truckDriverTaskId: "truckDriverBasicInfoId",
    workSheet1099TaskId: "workSheet1099Id",
  };

  // Helper function to check if data exists for a tab
  const hasTabData = (key) => {
    console.log('Checking data for key:', key);
    console.log('Modal data:', modalData);
    
    if (!modalData) {
      console.log('No modalData');
      return false;
    }
    
    // If modalData is not an array, wrap it in an array
    const dataArray = Array.isArray(modalData) ? modalData : [modalData];
    
    const hasData = dataArray.some(item => {
      console.log('Checking item:', item);
      const data = item[key];
      console.log('Data for key:', data);
      
      if (!data) return false;
      if (Array.isArray(data)) return data.length > 0;
      if (typeof data === 'object') return Object.keys(data).length > 0;
      return true;
    });
    
    console.log('Has data for key', key, ':', hasData);
    return hasData;
  };

  // All possible tabs
  const allTabs = [
    { key: "personalCollectionTaskId", label: "Personal Collection" },
    { key: "generalBusinessTaskId", label: "General Business" },
    { key: "rentalPropertyTaskId", label: "Rental Property" },
    { key: "truckDriverTaskId", label: "Truck Driver" },
    { key: "workSheet1099TaskId", label: "Work Sheet 1099" },
  ];

  // State for tabs
  const [isLoading, setIsLoading] = useState(true);
  const [mainTabs, setMainTabs] = useState([]);
  const [mainTabIndex, setMainTabIndex] = useState(0);
  const [subTabIndex, setSubTabIndex] = useState(0);

  // Initialize mainTabs and handle updates
  useEffect(() => {
    console.log('Effect running with modalData:', modalData);
    
    setIsLoading(true);
    try {
      // If modalData is not an array, wrap it in an array
      const dataToProcess = Array.isArray(modalData) ? modalData : [modalData];
      
      console.log('Processing data:', dataToProcess);
      
      const availableTabs = allTabs.filter(tab => {
        const hasData = hasTabData(tab.key);
        console.log(`Tab ${tab.label} has data:`, hasData);
        return hasData;
      });
      
      console.log('Available tabs:', availableTabs);
      setMainTabs(availableTabs);
      
      // Reset mainTabIndex if it becomes invalid
      if (mainTabIndex >= availableTabs.length) {
        setMainTabIndex(0);
      }
    } finally {
      setIsLoading(false);
    }
  }, [modalData]);
  const handleDownload = () => {
    const element = componentRef.current;
    const opt = {
      margin: 1,
      filename: "form.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
    };

    // New Promise-based API
    html2pdf().set(opt).from(element).save();
  };

  // Extract tasks for the selected main tab
  const selectedMainTab = mainTabs[mainTabIndex];
  console.log('Selected main tab:', selectedMainTab);
  
  // Handle both array and single object modalData
  const dataArray = Array.isArray(modalData) ? modalData : [modalData];
  console.log('Data array for tasks:', dataArray);
  
  const selectedTasks = selectedMainTab
    ? dataArray.find(
        (item) => {
          console.log('Checking item for tasks:', item);
          console.log('Looking for key:', selectedMainTab.key);
          return item?.[selectedMainTab.key] !== undefined;
        }
      )?.[selectedMainTab.key] || []
    : [];
    
  console.log('Selected tasks:', selectedTasks);
  console.log(selectedTasks, modalData, "selectedMainTab", selectedMainTab, modalData);
  // Generate sub tabs based on taxYear
  const subTabs = selectedTasks.map((task) => {
    const taxYearField = taxYearKeyMap[selectedMainTab.key];
    console.log(taxYearField, "___task", task);
    return {
      taxYear:
        task?.informationType == "1099 Worksheet"
          ? task?.taxYear
          : task?.[taxYearField]?.taxYear || "Unknown Year",
      content: task, // Pass the entire task for rendering details
    };
  });

  console.log(subTabs, "subTabs_subTabs", subTabIndex);
  return (
    <>
      <Modal
        open={generalBusinessModal}
        onClose={() => setGeneralBusinessModal(!generalBusinessModal)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <AddNewBusinessContainer
          style={{
            width: "800px",
            maxHeight: "90vh",
            overflow: "auto",
            padding: "14px",
          }}
        >
          <Box sx={{ width: "100%", padding: "0 20px" }}>
            <FlexComp alignItems="center" justifyContent="space-between">
              <Span color="#000000" fontSize="20px" fontWeight="500">
                Tax Payers Information
              </Span>
              <CloseIcon
                onClick={() => setGeneralBusinessModal(!generalBusinessModal)}
                sx={{ cursor: "pointer" }}
              />
            </FlexComp>
          </Box>
          <Box sx={{ padding: "0px 20px", width: "100%" }}>
            {/* Main Tabs */}
            {!isLoading && mainTabs.length > 0 && (
              <Box sx={{ marginBottom: "10px" }}>
                <Tabs
                  value={mainTabIndex}
                  onChange={(e, newValue) => {
                    setMainTabIndex(newValue);
                    setSubTabIndex(0); // Reset sub-tab index when main tab changes
                  }}
                  variant="scrollable"
                  scrollButtons="auto"
                >
                  {mainTabs.map((tab, index) => (
                    <Tab key={index} label={tab.label} />
                  ))}
                </Tabs>
              </Box>
            )}
            
            {isLoading && (
              <Box sx={{ padding: "20px", textAlign: "center" }}>
                <Typography>Loading...</Typography>
              </Box>
            )}
            
            {!isLoading && mainTabs.length === 0 && (
              <Box sx={{ padding: "20px", textAlign: "center" }}>
                <Typography>No data available</Typography>
              </Box>
            )}

            {/* Sub Tabs */}
            {subTabs.length > 0 && (
              <>
                <Tabs
                  value={subTabIndex}
                  onChange={(e, newValue) => setSubTabIndex(newValue)}
                  variant="scrollable"
                  scrollButtons="auto"
                >
                  {subTabs.map((subTab, index) => (
                    <Tab
                      key={index}
                      label={subTab.taxYear}
                    />
                  ))}
                </Tabs>

                <Box sx={{ padding: "20px" }} ref={componentRef}>
                  {/* Render content for the selected sub-tab */}
                  <Typography variant="h6" sx={{ marginBottom: "10px" }}>
                    {`Details for ${subTabs[subTabIndex].taxYear}`}
                  </Typography>
                  {/* <pre>{JSON.stringify(subTabs[subTabIndex].content, null, 2)}</pre> */}

                  {subTabs[subTabIndex]?.content?.informationType ==
                    "Personal Collection" && (
                    // <div>Personal Collection</div>
                    <PersonalData clientData={subTabs[subTabIndex]?.content} />
                  )}
                  {subTabs[subTabIndex]?.content?.informationType ==
                    "General Business" && (
                    <BusinessData clientData={subTabs[subTabIndex]?.content} />
                  )}
                  {subTabs[subTabIndex]?.content?.informationType ==
                    "Rental Property" && (
                    <RentalData clientData={subTabs[subTabIndex]?.content} />
                  )}
                  {subTabs[subTabIndex]?.content?.informationType ==
                    "Truck Driver" && (
                    <TruckData clientData={subTabs[subTabIndex]?.content} />
                  )}
                  {subTabs[subTabIndex]?.content?.informationType ==
                    "1099 Worksheet" && (
                    <Formation1099 sheetData={subTabs[subTabIndex]?.content} />
                  )}
                </Box>
              </>
            )}

            {/* No Data Available */}
            {subTabs.length === 0 && (
              <Typography variant="h6" color="textSecondary">
                No data available for this category.
              </Typography>
            )}
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "end",
              gap: "15px",
            }}
          >
            <IconStyledButton
              width="150px"
              variant="text"
              color="white"
              fontSize="18px"
              padding="10px"
              onClick={handleDownload}
            >
              <DownloadIcon />
              Download
            </IconStyledButton>
            {download == "true" ? (
              <>
                <Button
                  text="Download"
                  width="150px"
                  type="submit"
                  fontSize="20px"
                  backgroundColor="#0B2558"
                  padding="10px"
                  color="#FFFFFF"
                  onClick={handleDownload}
                />
              </>
            ) : (
              <>
                {modalData?.[0]?.status !== "Data Completed" && (
                  <Button
                    text="Validate"
                    width="auto"
                    fontSize="20px"
                    padding="10px 40px"
                    backgroundColor="#00ADEF"
                    onClick={() => {
                      setGeneralBusinessModal(!generalBusinessModal);
                      setIsValidateTaxModal(!isValidateTaxModal);
                    }}
                  />
                )}
              </>
            )}

            <Button // Always show Cancel button
              text="Cancel"
              width="auto"
              fontSize="20px"
              padding="10px 40px"
              backgroundColor="rgba(239, 243, 253, 1)"
              color="
            rgba(174, 182, 207, 1)"
              onClick={() => setGeneralBusinessModal(!generalBusinessModal)}
            />
          </Box>
        </AddNewBusinessContainer>
      </Modal>
      <ValidateTaxModal
        handleYesClick={handleYesClick}
        isModalOpen={isValidateTaxModal}
        closeModal={() => setIsValidateTaxModal(!isValidateTaxModal)}
        paragraph="Are you sure you want to submit for review?"
        setGeneralBusinessModal={setGeneralBusinessModal}
        generalBusinessModal={generalBusinessModal}
      />
    </>
  );
};

export default ShowClientModal;
